import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { PrinterService } from 'src/app/provider/printer.service';
import { TokenFormModel } from '../../pages/auth/models/tokenform.model';
import { Printer } from '../../models/printer.model';

@Component({
  selector: 'kt-local-printer-setup',
  templateUrl: './local-printer-setup.component.html',
  styleUrls: ['./local-printer-setup.component.scss']
})
export class LocalPrinterSetupComponent implements OnInit {

  selectedPrinter: string = null;
  printerAlias: string = null;
  description: string = null;

  tokenForm: TokenFormModel = JSON.parse(localStorage.getItem('token_form'));

  processing = false;

  constructor(
    public printerServ: PrinterService,
    private changeDetect: ChangeDetectorRef
  ) { }

  async ngOnInit() {
    await this.printerServ.getLocalPrinters();
    await this.printerServ.getLocalPrinterQues();
  }

  async addPrinter() {

    this.processing = true;
    this.changeDetect.detectChanges();

    const NEWPRINTER = new Printer();

    NEWPRINTER.hotel_id = this.tokenForm.app_hotel_id;
    NEWPRINTER.description = this.description;
    NEWPRINTER.printer_name = this.selectedPrinter;
    NEWPRINTER.printer_alias = this.printerAlias;
    NEWPRINTER.host_name = this.printerServ.localPrinterMachines.hostname;

    try {
      await this.printerServ.postPrinter(NEWPRINTER);
      await this.printerServ.getLocalPrinterQues();
    } catch { }

    this.description = null;
    this.selectedPrinter = null;
    this.printerAlias = null;

    this.processing = false;
    this.changeDetect.detectChanges();
  }

  async deletePrinter(id: number) {
    await this.printerServ.deletePrinter(id);
    await this.printerServ.getLocalPrinters();
    await this.printerServ.getLocalPrinterQues();
    this.changeDetect.detectChanges();
  }

}
